import React, { useCallback, useEffect, useState } from 'react';
import { getAllPayments } from '../../../../api/payment/payment.api';
import JobBoardPagination from '../../../JobBoard/JobBoardPagination';
import PaymentsRow from './PaymentsRow';

const PaymentsList = () => {
  const [paymentsList, setPaymentsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchHistory = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await getAllPayments(currentPage - 1, 12);
      setPaymentsList(data.content || []);
      setTotalPages(data.totalPages || 1);
    } catch (error) {
      console.error('결제 내역을 불러오지 못했습니다.', error);
    } finally {
      setIsLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  return (
    // 표 머리글이 있는 tabletV 이상에서만 머리글 아래 띠(-mt-5)와 겹친다
    <div className='w-full min-w-0 flex flex-col justify-between rounded-[20px] tabletV:rounded-[30px] overflow-hidden px-2 pt-4 pb-10 bg-grayscale-gray00 gap-10 tabletV:-mt-5 relative z-10 min-h-[400px] tabletV:min-h-[664px]'>
      <div className='flex flex-col gap-2'>
        {isLoading ? (
          <div className='w-full p-10 flex justify-center text-text-placeholder typo-b14 h-[400px] tabletV:h-[664px]'>
            Loading...
          </div>
        ) : paymentsList.length === 0 ? (
          <div className='w-full p-10 flex items-center justify-center text-text-placeholder typo-b14 h-[400px] tabletV:h-[664px]'>
            <div className='pb-6'>No payments yet</div>
          </div>
        ) : (
          paymentsList.map((item, index) => (
            <PaymentsRow
              key={item.invoiceNumber ?? index}
              item={item}
              onFetch={fetchHistory}
            />
          ))
        )}
      </div>

      <JobBoardPagination
        isMyPage
        current={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default PaymentsList;
